import { render, staticRenderFns } from "./ModalNovaModalidade.vue?vue&type=template&id=2b577428&scoped=true"
import script from "./ModalNovaModalidade.vue?vue&type=script&lang=js"
export * from "./ModalNovaModalidade.vue?vue&type=script&lang=js"
import style0 from "./ModalNovaModalidade.vue?vue&type=style&index=0&id=2b577428&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b577428",
  null
  
)

export default component.exports